// Navigation, hub, breadcrumb, command palette and admin-invite strings for all 7 languages.

export const navContentDE = {
  "hub.feed.justNow": "gerade eben",
  "hub.feed.title": "Aktivitäten",
  "hub.feed.desc": "Was sich seit Ihrem letzten Besuch getan hat",
  "hub.feed.empty": "Noch keine Aktivitäten.",
  "hub.feed.new": "Neu",
  "hub.feed.newCount": "{{count}} neu seit letztem Besuch",
  "hub.feed.allCaughtUp": "Nichts Neues seit Ihrem letzten Besuch",
  "hub.feed.incoming_request": "<b>{{from}}</b> hat {{qty}} {{uom}} „{{material}}“ angefragt",
  "hub.feed.request_status": "Ihre Anfrage zu „{{material}}“ ist jetzt <b>{{status}}</b>",
  "hub.feed.offer_received": "Neues Angebot auf Ihr Gesuch „{{wanted}}“: {{qty}} {{unit}} à €{{price}}",
  "hub.feed.offer_status": "Ihr Angebot auf „{{wanted}}“ (€{{price}}/Einheit) ist jetzt <b>{{status}}</b>",
  "hub.feed.message": "Nachricht von <b>{{from}}</b>: {{preview}}",
  "hub.feed.transaction": "Transaktion {{order}} „{{title}}“ als {{role}} – <b>{{status}}</b>",
  "status.accepted": "Angenommen",
  "status.declined": "Abgelehnt",
  "status.countered": "Gegenangebot",
  "status.withdrawn": "Zurückgezogen",
  "status.awaiting_logistics_confirmation": "Logistik-Bestätigung ausstehend",
  "status.transaction_created": "Transaktion erstellt",
  "status.viewed_by_buyer": "Vom Käufer gesehen",
  "status.cancelled": "Storniert",
  "status.submitted": "Eingereicht",
  "nav.masterData": "Stammdaten-Pflege",
  "nav.hub": "Mein Bereich",
  "nav.marketplace": "Marktplatz",
  "nav.myListings": "Meine Inserate",
  "nav.wanted": "Gesuche",
  "nav.myOffers": "Meine Angebote",
  "nav.savedSearches": "Gespeicherte Suchen",
  "nav.messages": "Nachrichten",
  "nav.myReports": "Meine Meldungen",
  "nav.guide": "Hilfe & FAQ",
  "nav.notificationSettings": "E-Mail-Benachrichtigungen",
  "nav.sellerPortal": "Verkäufer-Portal",
  "nav.groupAdminPortal": "Gruppen-Admin Portal",
  "nav.commission": "Provisionen",
  "nav.subscriptions": "Abonnements",
  "nav.myCompany": "Mein Unternehmen",
  "nav.createListing": "Inserat erstellen",
  "nav.sec.marketplace": "Marktplatz",
  "nav.sec.trade": "Handel & Kommunikation",
  "nav.sec.management": "Verwaltung",
  "nav.sec.portals": "Portale",
  "nav.sec.platformAdmin": "Plattform-Admin",
  "nav.sec.settings": "Einstellungen",
  "nav.quickNav": "Schnellnavigation",
  "nav.groupSwitched": "Gruppe gewechselt: {{name}}",
  "nav.groupSwitchFailed": "Gruppenwechsel fehlgeschlagen",
  "cmd.placeholder": "Seite oder Aktion suchen …",
  "cmd.empty": "Keine Treffer",
  "cmd.pages": "Seiten",
  "cmd.actions": "Aktionen",
  "cmd.searchFor": "Marktplatz durchsuchen nach „{{q}}“",
  "cmd.hint": "Strg+K für Schnellnavigation",
  "breadcrumb.home": "Start",
  "breadcrumb.details": "Details",
  "breadcrumb.edit": "Bearbeiten",
  "breadcrumb.new": "Neu",
  "hub.title": "Mein Bereich",
  "hub.greeting": "Willkommen zurück, {{name}}",
  "hub.subtitle": "Ihre Aktivitäten, offenen Aufgaben und Kennzahlen auf einen Blick.",
  "hub.actionsTitle": "Handlungsbedarf",
  "hub.actionsDesc": "Das wartet aktuell auf Ihre Reaktion",
  "hub.noActions": "Alles erledigt – keine offenen Aufgaben.",
  "hub.quickActions": "Schnellaktionen",
  "hub.recentTitle": "Letzte Transaktionen",
  "hub.recentEmpty": "Noch keine Transaktionen.",
  "hub.viewAll": "Alle anzeigen",
  "hub.asBuyer": "Käufer",
  "hub.asSeller": "Verkäufer",
  "hub.tile.my_materials": "Meine Artikel",
  "hub.tile.my_listings": "Aktive Inserate",
  "hub.tile.watchlist": "Merkliste",
  "hub.tile.incoming_requests": "Eingehende Anfragen",
  "hub.tile.outgoing_requests": "Meine Anfragen",
  "hub.tile.unread_messages": "Ungelesene Nachrichten",
  "hub.tile.offers_received": "Erhaltene Angebote",
  "hub.tile.my_offers_active": "Offene Angebote",
  "hub.tile.my_wanted_active": "Meine Gesuche",
  "hub.tile.wanted_matches": "Passende Gesuche",
  "hub.tile.transactions_active": "Laufende Transaktionen",
  "hub.tile.transactions_total": "Transaktionen gesamt",
  "hub.action.incoming_requests": "{{count}} Anfrage(n) warten auf Ihre Freigabe",
  "hub.action.unread_messages": "{{count}} ungelesene Nachricht(en)",
  "hub.action.offers_received": "{{count}} neue Angebot(e) auf Ihre Gesuche",
  "hub.action.offers_countered": "{{count}} Gegenangebot(e) benötigen Ihre Antwort",
  "hub.action.to_ship": "{{count}} bezahlte Bestellung(en) versandbereit",
  "hub.action.wanted_matches": "{{count}} Gesuch(e) passen zu Ihren Materialien",
  "hub.loadError": "Übersicht konnte nicht geladen werden",
  "adminInvite.button": "Admin einladen",
  "adminInvite.title": "Plattform-Admin einladen",
  "adminInvite.desc": "Die Person erhält per E-Mail einen Link und legt damit ein Admin-Konto an.",
  "adminInvite.email": "E-Mail-Adresse",
  "adminInvite.message": "Persönliche Nachricht (optional)",
  "adminInvite.send": "Einladung senden",
  "adminInvite.sent": "Einladung gesendet",
  "adminInvite.sentNoMail": "Einladung erstellt – E-Mail konnte nicht gesendet werden. Link kopieren:",
  "adminInvite.pending": "Offene Admin-Einladungen",
  "adminInvite.none": "Keine offenen Admin-Einladungen",
  "adminInvite.revoke": "Zurückziehen",
  "adminInvite.revoked": "Einladung zurückgezogen",
  "adminInvite.expires": "gültig bis",
  "adminInvite.invitedBy": "eingeladen von",
  "adminInvite.acceptTitle": "Admin-Konto erstellen",
  "adminInvite.acceptDesc": "{{by}} hat Sie als Plattform-Administrator für Surplify eingeladen.",
  "adminInvite.name": "Ihr Name",
  "adminInvite.password": "Passwort",
  "adminInvite.confirm": "Passwort bestätigen",
  "adminInvite.create": "Konto erstellen & anmelden",
  "adminInvite.mismatch": "Passwörter stimmen nicht überein",
  "adminInvite.invalid": "Diese Einladung ist nicht mehr gültig ({{status}}).",
  "adminInvite.deleteAdminHint": "Achtung: Sie löschen ein Admin-Konto.",
};

export const navContentEN = {
  "hub.feed.justNow": "just now",
  "hub.feed.title": "Activity",
  "hub.feed.desc": "What happened since your last visit",
  "hub.feed.empty": "No activity yet.",
  "hub.feed.new": "New",
  "hub.feed.newCount": "{{count}} new since last visit",
  "hub.feed.allCaughtUp": "Nothing new since your last visit",
  "hub.feed.incoming_request": "<b>{{from}}</b> requested {{qty}} {{uom}} of “{{material}}”",
  "hub.feed.request_status": "Your request for “{{material}}” is now <b>{{status}}</b>",
  "hub.feed.offer_received": "New offer on your wanted ad “{{wanted}}”: {{qty}} {{unit}} at €{{price}}",
  "hub.feed.offer_status": "Your offer on “{{wanted}}” (€{{price}}/unit) is now <b>{{status}}</b>",
  "hub.feed.message": "Message from <b>{{from}}</b>: {{preview}}",
  "hub.feed.transaction": "Transaction {{order}} “{{title}}” as {{role}} – <b>{{status}}</b>",
  "status.accepted": "Accepted",
  "status.declined": "Declined",
  "status.countered": "Countered",
  "status.withdrawn": "Withdrawn",
  "status.awaiting_logistics_confirmation": "Awaiting logistics confirmation",
  "status.transaction_created": "Transaction created",
  "status.viewed_by_buyer": "Viewed by buyer",
  "status.cancelled": "Cancelled",
  "status.submitted": "Submitted",
  "nav.masterData": "Master Data",
  "nav.hub": "My Hub",
  "nav.marketplace": "Marketplace",
  "nav.myListings": "My Listings",
  "nav.wanted": "Wanted Ads",
  "nav.myOffers": "My Offers",
  "nav.savedSearches": "Saved Searches",
  "nav.messages": "Messages",
  "nav.myReports": "My Reports",
  "nav.guide": "Help & FAQ",
  "nav.notificationSettings": "Email Notifications",
  "nav.sellerPortal": "Seller Portal",
  "nav.groupAdminPortal": "Group Admin Portal",
  "nav.commission": "Commissions",
  "nav.subscriptions": "Subscriptions",
  "nav.myCompany": "My Company",
  "nav.createListing": "Create Listing",
  "nav.sec.marketplace": "Marketplace",
  "nav.sec.trade": "Trade & Communication",
  "nav.sec.management": "Management",
  "nav.sec.portals": "Portals",
  "nav.sec.platformAdmin": "Platform Admin",
  "nav.sec.settings": "Settings",
  "nav.quickNav": "Quick navigation",
  "nav.groupSwitched": "Switched group: {{name}}",
  "nav.groupSwitchFailed": "Group switch failed",
  "cmd.placeholder": "Search pages or actions …",
  "cmd.empty": "No results",
  "cmd.pages": "Pages",
  "cmd.actions": "Actions",
  "cmd.searchFor": "Search marketplace for “{{q}}”",
  "cmd.hint": "Ctrl+K for quick navigation",
  "breadcrumb.home": "Home",
  "breadcrumb.details": "Details",
  "breadcrumb.edit": "Edit",
  "breadcrumb.new": "New",
  "hub.title": "My Hub",
  "hub.greeting": "Welcome back, {{name}}",
  "hub.subtitle": "Your activity, open tasks and key figures at a glance.",
  "hub.actionsTitle": "Needs your attention",
  "hub.actionsDesc": "Items currently waiting for your response",
  "hub.noActions": "All caught up – nothing pending.",
  "hub.quickActions": "Quick actions",
  "hub.recentTitle": "Recent transactions",
  "hub.recentEmpty": "No transactions yet.",
  "hub.viewAll": "View all",
  "hub.asBuyer": "Buyer",
  "hub.asSeller": "Seller",
  "hub.tile.my_materials": "My Materials",
  "hub.tile.my_listings": "Active Listings",
  "hub.tile.watchlist": "Watchlist",
  "hub.tile.incoming_requests": "Incoming Requests",
  "hub.tile.outgoing_requests": "My Requests",
  "hub.tile.unread_messages": "Unread Messages",
  "hub.tile.offers_received": "Offers Received",
  "hub.tile.my_offers_active": "Open Offers",
  "hub.tile.my_wanted_active": "My Wanted Ads",
  "hub.tile.wanted_matches": "Matching Wanted Ads",
  "hub.tile.transactions_active": "Active Transactions",
  "hub.tile.transactions_total": "Total Transactions",
  "hub.action.incoming_requests": "{{count}} request(s) awaiting your approval",
  "hub.action.unread_messages": "{{count}} unread message(s)",
  "hub.action.offers_received": "{{count}} new offer(s) on your wanted ads",
  "hub.action.offers_countered": "{{count}} counter offer(s) need your reply",
  "hub.action.to_ship": "{{count}} paid order(s) ready to ship",
  "hub.action.wanted_matches": "{{count}} wanted ad(s) match your materials",
  "hub.loadError": "Could not load overview",
  "adminInvite.button": "Invite Admin",
  "adminInvite.title": "Invite Platform Admin",
  "adminInvite.desc": "The person receives an email link and creates an admin account with it.",
  "adminInvite.email": "Email address",
  "adminInvite.message": "Personal message (optional)",
  "adminInvite.send": "Send invitation",
  "adminInvite.sent": "Invitation sent",
  "adminInvite.sentNoMail": "Invitation created – email could not be sent. Copy link:",
  "adminInvite.pending": "Pending admin invitations",
  "adminInvite.none": "No pending admin invitations",
  "adminInvite.revoke": "Revoke",
  "adminInvite.revoked": "Invitation revoked",
  "adminInvite.expires": "valid until",
  "adminInvite.invitedBy": "invited by",
  "adminInvite.acceptTitle": "Create admin account",
  "adminInvite.acceptDesc": "{{by}} invited you as a platform administrator for Surplify.",
  "adminInvite.name": "Your name",
  "adminInvite.password": "Password",
  "adminInvite.confirm": "Confirm password",
  "adminInvite.create": "Create account & sign in",
  "adminInvite.mismatch": "Passwords do not match",
  "adminInvite.invalid": "This invitation is no longer valid ({{status}}).",
  "adminInvite.deleteAdminHint": "Warning: you are deleting an admin account.",
};

export const navContentES = {
  "hub.feed.justNow": "ahora mismo",
  "hub.feed.title": "Actividad",
  "hub.feed.desc": "Lo que ha pasado desde su última visita",
  "hub.feed.empty": "Aún no hay actividad.",
  "hub.feed.new": "Nuevo",
  "hub.feed.newCount": "{{count}} novedades desde la última visita",
  "hub.feed.allCaughtUp": "Nada nuevo desde su última visita",
  "hub.feed.incoming_request": "<b>{{from}}</b> solicitó {{qty}} {{uom}} de «{{material}}»",
  "hub.feed.request_status": "Su solicitud de «{{material}}» ahora está <b>{{status}}</b>",
  "hub.feed.offer_received": "Nueva oferta en su búsqueda «{{wanted}}»: {{qty}} {{unit}} a €{{price}}",
  "hub.feed.offer_status": "Su oferta para «{{wanted}}» (€{{price}}/unidad) ahora está <b>{{status}}</b>",
  "hub.feed.message": "Mensaje de <b>{{from}}</b>: {{preview}}",
  "hub.feed.transaction": "Transacción {{order}} «{{title}}» como {{role}} – <b>{{status}}</b>",
  "status.accepted": "Aceptada",
  "status.declined": "Rechazada",
  "status.countered": "Contraoferta",
  "status.withdrawn": "Retirada",
  "status.awaiting_logistics_confirmation": "Esperando confirmación logística",
  "status.transaction_created": "Transacción creada",
  "status.viewed_by_buyer": "Vista por el comprador",
  "status.cancelled": "Cancelada",
  "status.submitted": "Enviada",
  "nav.masterData": "Datos maestros",
  "nav.hub": "Mi área",
  "nav.marketplace": "Mercado",
  "nav.myListings": "Mis anuncios",
  "nav.wanted": "Se busca",
  "nav.myOffers": "Mis ofertas",
  "nav.savedSearches": "Búsquedas guardadas",
  "nav.messages": "Mensajes",
  "nav.myReports": "Mis reportes",
  "nav.guide": "Ayuda y FAQ",
  "nav.notificationSettings": "Notificaciones por correo",
  "nav.sellerPortal": "Portal del vendedor",
  "nav.groupAdminPortal": "Portal admin de grupo",
  "nav.commission": "Comisiones",
  "nav.subscriptions": "Suscripciones",
  "nav.myCompany": "Mi empresa",
  "nav.createListing": "Crear anuncio",
  "nav.sec.marketplace": "Mercado",
  "nav.sec.trade": "Comercio y comunicación",
  "nav.sec.management": "Gestión",
  "nav.sec.portals": "Portales",
  "nav.sec.platformAdmin": "Admin de plataforma",
  "nav.sec.settings": "Ajustes",
  "nav.quickNav": "Navegación rápida",
  "nav.groupSwitched": "Grupo cambiado: {{name}}",
  "nav.groupSwitchFailed": "Error al cambiar de grupo",
  "cmd.placeholder": "Buscar página o acción …",
  "cmd.empty": "Sin resultados",
  "cmd.pages": "Páginas",
  "cmd.actions": "Acciones",
  "cmd.searchFor": "Buscar «{{q}}» en el mercado",
  "cmd.hint": "Ctrl+K para navegación rápida",
  "breadcrumb.home": "Inicio",
  "breadcrumb.details": "Detalles",
  "breadcrumb.edit": "Editar",
  "breadcrumb.new": "Nuevo",
  "hub.title": "Mi área",
  "hub.greeting": "Bienvenido de nuevo, {{name}}",
  "hub.subtitle": "Su actividad, tareas pendientes y cifras clave de un vistazo.",
  "hub.actionsTitle": "Requiere su atención",
  "hub.actionsDesc": "Elementos que esperan su respuesta",
  "hub.noActions": "Todo al día – nada pendiente.",
  "hub.quickActions": "Acciones rápidas",
  "hub.recentTitle": "Transacciones recientes",
  "hub.recentEmpty": "Aún no hay transacciones.",
  "hub.viewAll": "Ver todo",
  "hub.asBuyer": "Comprador",
  "hub.asSeller": "Vendedor",
  "hub.tile.my_materials": "Mis materiales",
  "hub.tile.my_listings": "Anuncios activos",
  "hub.tile.watchlist": "Favoritos",
  "hub.tile.incoming_requests": "Solicitudes entrantes",
  "hub.tile.outgoing_requests": "Mis solicitudes",
  "hub.tile.unread_messages": "Mensajes sin leer",
  "hub.tile.offers_received": "Ofertas recibidas",
  "hub.tile.my_offers_active": "Ofertas abiertas",
  "hub.tile.my_wanted_active": "Mis anuncios de búsqueda",
  "hub.tile.wanted_matches": "Búsquedas coincidentes",
  "hub.tile.transactions_active": "Transacciones en curso",
  "hub.tile.transactions_total": "Transacciones totales",
  "hub.action.incoming_requests": "{{count}} solicitud(es) esperan su aprobación",
  "hub.action.unread_messages": "{{count}} mensaje(s) sin leer",
  "hub.action.offers_received": "{{count}} oferta(s) nueva(s) en sus búsquedas",
  "hub.action.offers_countered": "{{count}} contraoferta(s) requieren su respuesta",
  "hub.action.to_ship": "{{count}} pedido(s) pagado(s) listo(s) para enviar",
  "hub.action.wanted_matches": "{{count}} búsqueda(s) coinciden con sus materiales",
  "hub.loadError": "No se pudo cargar el resumen",
  "adminInvite.button": "Invitar admin",
  "adminInvite.title": "Invitar administrador de plataforma",
  "adminInvite.desc": "La persona recibe un enlace por correo y crea con él una cuenta de administrador.",
  "adminInvite.email": "Correo electrónico",
  "adminInvite.message": "Mensaje personal (opcional)",
  "adminInvite.send": "Enviar invitación",
  "adminInvite.sent": "Invitación enviada",
  "adminInvite.sentNoMail": "Invitación creada – no se pudo enviar el correo. Copie el enlace:",
  "adminInvite.pending": "Invitaciones de admin pendientes",
  "adminInvite.none": "No hay invitaciones pendientes",
  "adminInvite.revoke": "Revocar",
  "adminInvite.revoked": "Invitación revocada",
  "adminInvite.expires": "válida hasta",
  "adminInvite.invitedBy": "invitado por",
  "adminInvite.acceptTitle": "Crear cuenta de administrador",
  "adminInvite.acceptDesc": "{{by}} le ha invitado como administrador de plataforma de Surplify.",
  "adminInvite.name": "Su nombre",
  "adminInvite.password": "Contraseña",
  "adminInvite.confirm": "Confirmar contraseña",
  "adminInvite.create": "Crear cuenta e iniciar sesión",
  "adminInvite.mismatch": "Las contraseñas no coinciden",
  "adminInvite.invalid": "Esta invitación ya no es válida ({{status}}).",
  "adminInvite.deleteAdminHint": "Atención: está eliminando una cuenta de administrador.",
};

export const navContentFR = {
  "hub.feed.justNow": "à l'instant",
  "hub.feed.title": "Activité",
  "hub.feed.desc": "Ce qui s'est passé depuis votre dernière visite",
  "hub.feed.empty": "Aucune activité pour l'instant.",
  "hub.feed.new": "Nouveau",
  "hub.feed.newCount": "{{count}} nouveautés depuis la dernière visite",
  "hub.feed.allCaughtUp": "Rien de nouveau depuis votre dernière visite",
  "hub.feed.incoming_request": "<b>{{from}}</b> a demandé {{qty}} {{uom}} de « {{material}} »",
  "hub.feed.request_status": "Votre demande pour « {{material}} » est maintenant <b>{{status}}</b>",
  "hub.feed.offer_received": "Nouvelle offre sur votre recherche « {{wanted}} » : {{qty}} {{unit}} à {{price}} €",
  "hub.feed.offer_status": "Votre offre pour « {{wanted}} » ({{price}} €/unité) est maintenant <b>{{status}}</b>",
  "hub.feed.message": "Message de <b>{{from}}</b> : {{preview}}",
  "hub.feed.transaction": "Transaction {{order}} « {{title}} » en tant que {{role}} – <b>{{status}}</b>",
  "status.accepted": "Acceptée",
  "status.declined": "Refusée",
  "status.countered": "Contre-offre",
  "status.withdrawn": "Retirée",
  "status.awaiting_logistics_confirmation": "Confirmation logistique en attente",
  "status.transaction_created": "Transaction créée",
  "status.viewed_by_buyer": "Vue par l'acheteur",
  "status.cancelled": "Annulée",
  "status.submitted": "Soumise",
  "nav.masterData": "Données de référence",
  "nav.hub": "Mon espace",
  "nav.marketplace": "Marché",
  "nav.myListings": "Mes annonces",
  "nav.wanted": "Recherches",
  "nav.myOffers": "Mes offres",
  "nav.savedSearches": "Recherches enregistrées",
  "nav.messages": "Messages",
  "nav.myReports": "Mes signalements",
  "nav.guide": "Aide & FAQ",
  "nav.notificationSettings": "Notifications e-mail",
  "nav.sellerPortal": "Portail vendeur",
  "nav.groupAdminPortal": "Portail admin groupe",
  "nav.commission": "Commissions",
  "nav.subscriptions": "Abonnements",
  "nav.myCompany": "Mon entreprise",
  "nav.createListing": "Créer une annonce",
  "nav.sec.marketplace": "Marché",
  "nav.sec.trade": "Commerce & communication",
  "nav.sec.management": "Gestion",
  "nav.sec.portals": "Portails",
  "nav.sec.platformAdmin": "Admin plateforme",
  "nav.sec.settings": "Paramètres",
  "nav.quickNav": "Navigation rapide",
  "nav.groupSwitched": "Groupe changé : {{name}}",
  "nav.groupSwitchFailed": "Échec du changement de groupe",
  "cmd.placeholder": "Rechercher une page ou une action …",
  "cmd.empty": "Aucun résultat",
  "cmd.pages": "Pages",
  "cmd.actions": "Actions",
  "cmd.searchFor": "Rechercher « {{q}} » sur le marché",
  "cmd.hint": "Ctrl+K pour la navigation rapide",
  "breadcrumb.home": "Accueil",
  "breadcrumb.details": "Détails",
  "breadcrumb.edit": "Modifier",
  "breadcrumb.new": "Nouveau",
  "hub.title": "Mon espace",
  "hub.greeting": "Bon retour, {{name}}",
  "hub.subtitle": "Votre activité, vos tâches ouvertes et vos chiffres clés en un coup d'œil.",
  "hub.actionsTitle": "À traiter",
  "hub.actionsDesc": "Éléments en attente de votre réponse",
  "hub.noActions": "Tout est à jour – rien en attente.",
  "hub.quickActions": "Actions rapides",
  "hub.recentTitle": "Transactions récentes",
  "hub.recentEmpty": "Aucune transaction pour l'instant.",
  "hub.viewAll": "Tout afficher",
  "hub.asBuyer": "Acheteur",
  "hub.asSeller": "Vendeur",
  "hub.tile.my_materials": "Mes matériaux",
  "hub.tile.my_listings": "Annonces actives",
  "hub.tile.watchlist": "Favoris",
  "hub.tile.incoming_requests": "Demandes entrantes",
  "hub.tile.outgoing_requests": "Mes demandes",
  "hub.tile.unread_messages": "Messages non lus",
  "hub.tile.offers_received": "Offres reçues",
  "hub.tile.my_offers_active": "Offres ouvertes",
  "hub.tile.my_wanted_active": "Mes recherches",
  "hub.tile.wanted_matches": "Recherches correspondantes",
  "hub.tile.transactions_active": "Transactions en cours",
  "hub.tile.transactions_total": "Transactions totales",
  "hub.action.incoming_requests": "{{count}} demande(s) attendent votre validation",
  "hub.action.unread_messages": "{{count}} message(s) non lu(s)",
  "hub.action.offers_received": "{{count}} nouvelle(s) offre(s) sur vos recherches",
  "hub.action.offers_countered": "{{count}} contre-offre(s) attendent votre réponse",
  "hub.action.to_ship": "{{count}} commande(s) payée(s) prête(s) à expédier",
  "hub.action.wanted_matches": "{{count}} recherche(s) correspondent à vos matériaux",
  "hub.loadError": "Impossible de charger l'aperçu",
  "adminInvite.button": "Inviter un admin",
  "adminInvite.title": "Inviter un administrateur plateforme",
  "adminInvite.desc": "La personne reçoit un lien par e-mail et crée ainsi un compte administrateur.",
  "adminInvite.email": "Adresse e-mail",
  "adminInvite.message": "Message personnel (facultatif)",
  "adminInvite.send": "Envoyer l'invitation",
  "adminInvite.sent": "Invitation envoyée",
  "adminInvite.sentNoMail": "Invitation créée – l'e-mail n'a pas pu être envoyé. Copiez le lien :",
  "adminInvite.pending": "Invitations admin en attente",
  "adminInvite.none": "Aucune invitation en attente",
  "adminInvite.revoke": "Révoquer",
  "adminInvite.revoked": "Invitation révoquée",
  "adminInvite.expires": "valable jusqu'au",
  "adminInvite.invitedBy": "invité par",
  "adminInvite.acceptTitle": "Créer un compte administrateur",
  "adminInvite.acceptDesc": "{{by}} vous a invité comme administrateur plateforme de Surplify.",
  "adminInvite.name": "Votre nom",
  "adminInvite.password": "Mot de passe",
  "adminInvite.confirm": "Confirmer le mot de passe",
  "adminInvite.create": "Créer le compte & se connecter",
  "adminInvite.mismatch": "Les mots de passe ne correspondent pas",
  "adminInvite.invalid": "Cette invitation n'est plus valable ({{status}}).",
  "adminInvite.deleteAdminHint": "Attention : vous supprimez un compte administrateur.",
};

export const navContentIT = {
  "hub.feed.justNow": "proprio ora",
  "hub.feed.title": "Attività",
  "hub.feed.desc": "Cosa è successo dalla sua ultima visita",
  "hub.feed.empty": "Nessuna attività.",
  "hub.feed.new": "Nuovo",
  "hub.feed.newCount": "{{count}} novità dall'ultima visita",
  "hub.feed.allCaughtUp": "Niente di nuovo dalla sua ultima visita",
  "hub.feed.incoming_request": "<b>{{from}}</b> ha richiesto {{qty}} {{uom}} di «{{material}}»",
  "hub.feed.request_status": "La sua richiesta per «{{material}}» ora è <b>{{status}}</b>",
  "hub.feed.offer_received": "Nuova offerta sulla sua richiesta «{{wanted}}»: {{qty}} {{unit}} a €{{price}}",
  "hub.feed.offer_status": "La sua offerta per «{{wanted}}» (€{{price}}/unità) ora è <b>{{status}}</b>",
  "hub.feed.message": "Messaggio da <b>{{from}}</b>: {{preview}}",
  "hub.feed.transaction": "Transazione {{order}} «{{title}}» come {{role}} – <b>{{status}}</b>",
  "status.accepted": "Accettata",
  "status.declined": "Rifiutata",
  "status.countered": "Controfferta",
  "status.withdrawn": "Ritirata",
  "status.awaiting_logistics_confirmation": "In attesa di conferma logistica",
  "status.transaction_created": "Transazione creata",
  "status.viewed_by_buyer": "Vista dall'acquirente",
  "status.cancelled": "Annullata",
  "status.submitted": "Inviata",
  "nav.masterData": "Dati anagrafici",
  "nav.hub": "La mia area",
  "nav.marketplace": "Mercato",
  "nav.myListings": "I miei annunci",
  "nav.wanted": "Richieste",
  "nav.myOffers": "Le mie offerte",
  "nav.savedSearches": "Ricerche salvate",
  "nav.messages": "Messaggi",
  "nav.myReports": "Le mie segnalazioni",
  "nav.guide": "Aiuto & FAQ",
  "nav.notificationSettings": "Notifiche e-mail",
  "nav.sellerPortal": "Portale venditore",
  "nav.groupAdminPortal": "Portale admin gruppo",
  "nav.commission": "Commissioni",
  "nav.subscriptions": "Abbonamenti",
  "nav.myCompany": "La mia azienda",
  "nav.createListing": "Crea annuncio",
  "nav.sec.marketplace": "Mercato",
  "nav.sec.trade": "Commercio & comunicazione",
  "nav.sec.management": "Gestione",
  "nav.sec.portals": "Portali",
  "nav.sec.platformAdmin": "Admin piattaforma",
  "nav.sec.settings": "Impostazioni",
  "nav.quickNav": "Navigazione rapida",
  "nav.groupSwitched": "Gruppo cambiato: {{name}}",
  "nav.groupSwitchFailed": "Cambio gruppo non riuscito",
  "cmd.placeholder": "Cerca pagina o azione …",
  "cmd.empty": "Nessun risultato",
  "cmd.pages": "Pagine",
  "cmd.actions": "Azioni",
  "cmd.searchFor": "Cerca «{{q}}» nel mercato",
  "cmd.hint": "Ctrl+K per la navigazione rapida",
  "breadcrumb.home": "Home",
  "breadcrumb.details": "Dettagli",
  "breadcrumb.edit": "Modifica",
  "breadcrumb.new": "Nuovo",
  "hub.title": "La mia area",
  "hub.greeting": "Bentornato, {{name}}",
  "hub.subtitle": "Attività, compiti aperti e indicatori chiave a colpo d'occhio.",
  "hub.actionsTitle": "Da gestire",
  "hub.actionsDesc": "Elementi in attesa della sua risposta",
  "hub.noActions": "Tutto in ordine – niente in sospeso.",
  "hub.quickActions": "Azioni rapide",
  "hub.recentTitle": "Transazioni recenti",
  "hub.recentEmpty": "Nessuna transazione.",
  "hub.viewAll": "Mostra tutto",
  "hub.asBuyer": "Acquirente",
  "hub.asSeller": "Venditore",
  "hub.tile.my_materials": "I miei materiali",
  "hub.tile.my_listings": "Annunci attivi",
  "hub.tile.watchlist": "Preferiti",
  "hub.tile.incoming_requests": "Richieste in arrivo",
  "hub.tile.outgoing_requests": "Le mie richieste",
  "hub.tile.unread_messages": "Messaggi non letti",
  "hub.tile.offers_received": "Offerte ricevute",
  "hub.tile.my_offers_active": "Offerte aperte",
  "hub.tile.my_wanted_active": "Le mie richieste",
  "hub.tile.wanted_matches": "Richieste corrispondenti",
  "hub.tile.transactions_active": "Transazioni in corso",
  "hub.tile.transactions_total": "Transazioni totali",
  "hub.action.incoming_requests": "{{count}} richiesta/e in attesa di approvazione",
  "hub.action.unread_messages": "{{count}} messaggio/i non letto/i",
  "hub.action.offers_received": "{{count}} nuova/e offerta/e sulle sue richieste",
  "hub.action.offers_countered": "{{count}} controfferta/e richiedono risposta",
  "hub.action.to_ship": "{{count}} ordine/i pagato/i pronto/i per la spedizione",
  "hub.action.wanted_matches": "{{count}} richiesta/e corrispondono ai suoi materiali",
  "hub.loadError": "Impossibile caricare la panoramica",
  "adminInvite.button": "Invita admin",
  "adminInvite.title": "Invita amministratore piattaforma",
  "adminInvite.desc": "La persona riceve un link via e-mail e crea con esso un account amministratore.",
  "adminInvite.email": "Indirizzo e-mail",
  "adminInvite.message": "Messaggio personale (facoltativo)",
  "adminInvite.send": "Invia invito",
  "adminInvite.sent": "Invito inviato",
  "adminInvite.sentNoMail": "Invito creato – e-mail non inviata. Copia il link:",
  "adminInvite.pending": "Inviti admin in sospeso",
  "adminInvite.none": "Nessun invito in sospeso",
  "adminInvite.revoke": "Revoca",
  "adminInvite.revoked": "Invito revocato",
  "adminInvite.expires": "valido fino al",
  "adminInvite.invitedBy": "invitato da",
  "adminInvite.acceptTitle": "Crea account amministratore",
  "adminInvite.acceptDesc": "{{by}} l'ha invitato come amministratore piattaforma di Surplify.",
  "adminInvite.name": "Il suo nome",
  "adminInvite.password": "Password",
  "adminInvite.confirm": "Conferma password",
  "adminInvite.create": "Crea account e accedi",
  "adminInvite.mismatch": "Le password non coincidono",
  "adminInvite.invalid": "Questo invito non è più valido ({{status}}).",
  "adminInvite.deleteAdminHint": "Attenzione: sta eliminando un account amministratore.",
};

export const navContentPT = {
  "hub.feed.justNow": "agora mesmo",
  "hub.feed.title": "Atividade",
  "hub.feed.desc": "O que aconteceu desde a sua última visita",
  "hub.feed.empty": "Ainda sem atividade.",
  "hub.feed.new": "Novo",
  "hub.feed.newCount": "{{count}} novidades desde a última visita",
  "hub.feed.allCaughtUp": "Nada de novo desde a sua última visita",
  "hub.feed.incoming_request": "<b>{{from}}</b> pediu {{qty}} {{uom}} de «{{material}}»",
  "hub.feed.request_status": "O seu pedido de «{{material}}» está agora <b>{{status}}</b>",
  "hub.feed.offer_received": "Nova oferta na sua procura «{{wanted}}»: {{qty}} {{unit}} a €{{price}}",
  "hub.feed.offer_status": "A sua oferta para «{{wanted}}» (€{{price}}/unidade) está agora <b>{{status}}</b>",
  "hub.feed.message": "Mensagem de <b>{{from}}</b>: {{preview}}",
  "hub.feed.transaction": "Transação {{order}} «{{title}}» como {{role}} – <b>{{status}}</b>",
  "status.accepted": "Aceite",
  "status.declined": "Recusada",
  "status.countered": "Contraoferta",
  "status.withdrawn": "Retirada",
  "status.awaiting_logistics_confirmation": "A aguardar confirmação logística",
  "status.transaction_created": "Transação criada",
  "status.viewed_by_buyer": "Vista pelo comprador",
  "status.cancelled": "Cancelada",
  "status.submitted": "Submetida",
  "nav.masterData": "Dados mestres",
  "nav.hub": "Minha área",
  "nav.marketplace": "Mercado",
  "nav.myListings": "Meus anúncios",
  "nav.wanted": "Procura-se",
  "nav.myOffers": "Minhas ofertas",
  "nav.savedSearches": "Pesquisas guardadas",
  "nav.messages": "Mensagens",
  "nav.myReports": "Meus relatórios",
  "nav.guide": "Ajuda & FAQ",
  "nav.notificationSettings": "Notificações por e-mail",
  "nav.sellerPortal": "Portal do vendedor",
  "nav.groupAdminPortal": "Portal admin do grupo",
  "nav.commission": "Comissões",
  "nav.subscriptions": "Subscrições",
  "nav.myCompany": "Minha empresa",
  "nav.createListing": "Criar anúncio",
  "nav.sec.marketplace": "Mercado",
  "nav.sec.trade": "Comércio & comunicação",
  "nav.sec.management": "Gestão",
  "nav.sec.portals": "Portais",
  "nav.sec.platformAdmin": "Admin da plataforma",
  "nav.sec.settings": "Definições",
  "nav.quickNav": "Navegação rápida",
  "nav.groupSwitched": "Grupo alterado: {{name}}",
  "nav.groupSwitchFailed": "Falha ao mudar de grupo",
  "cmd.placeholder": "Procurar página ou ação …",
  "cmd.empty": "Sem resultados",
  "cmd.pages": "Páginas",
  "cmd.actions": "Ações",
  "cmd.searchFor": "Procurar «{{q}}» no mercado",
  "cmd.hint": "Ctrl+K para navegação rápida",
  "breadcrumb.home": "Início",
  "breadcrumb.details": "Detalhes",
  "breadcrumb.edit": "Editar",
  "breadcrumb.new": "Novo",
  "hub.title": "Minha área",
  "hub.greeting": "Bem-vindo de volta, {{name}}",
  "hub.subtitle": "A sua atividade, tarefas abertas e indicadores num só lugar.",
  "hub.actionsTitle": "Requer atenção",
  "hub.actionsDesc": "Itens à espera da sua resposta",
  "hub.noActions": "Tudo em dia – nada pendente.",
  "hub.quickActions": "Ações rápidas",
  "hub.recentTitle": "Transações recentes",
  "hub.recentEmpty": "Ainda sem transações.",
  "hub.viewAll": "Ver tudo",
  "hub.asBuyer": "Comprador",
  "hub.asSeller": "Vendedor",
  "hub.tile.my_materials": "Meus materiais",
  "hub.tile.my_listings": "Anúncios ativos",
  "hub.tile.watchlist": "Favoritos",
  "hub.tile.incoming_requests": "Pedidos recebidos",
  "hub.tile.outgoing_requests": "Meus pedidos",
  "hub.tile.unread_messages": "Mensagens não lidas",
  "hub.tile.offers_received": "Ofertas recebidas",
  "hub.tile.my_offers_active": "Ofertas abertas",
  "hub.tile.my_wanted_active": "Meus anúncios de procura",
  "hub.tile.wanted_matches": "Procuras correspondentes",
  "hub.tile.transactions_active": "Transações em curso",
  "hub.tile.transactions_total": "Transações totais",
  "hub.action.incoming_requests": "{{count}} pedido(s) aguardam a sua aprovação",
  "hub.action.unread_messages": "{{count}} mensagem(ns) não lida(s)",
  "hub.action.offers_received": "{{count}} nova(s) oferta(s) nas suas procuras",
  "hub.action.offers_countered": "{{count}} contraoferta(s) precisam da sua resposta",
  "hub.action.to_ship": "{{count}} encomenda(s) paga(s) pronta(s) a enviar",
  "hub.action.wanted_matches": "{{count}} procura(s) correspondem aos seus materiais",
  "hub.loadError": "Não foi possível carregar a visão geral",
  "adminInvite.button": "Convidar admin",
  "adminInvite.title": "Convidar administrador da plataforma",
  "adminInvite.desc": "A pessoa recebe um link por e-mail e cria com ele uma conta de administrador.",
  "adminInvite.email": "Endereço de e-mail",
  "adminInvite.message": "Mensagem pessoal (opcional)",
  "adminInvite.send": "Enviar convite",
  "adminInvite.sent": "Convite enviado",
  "adminInvite.sentNoMail": "Convite criado – e-mail não enviado. Copie o link:",
  "adminInvite.pending": "Convites de admin pendentes",
  "adminInvite.none": "Sem convites pendentes",
  "adminInvite.revoke": "Revogar",
  "adminInvite.revoked": "Convite revogado",
  "adminInvite.expires": "válido até",
  "adminInvite.invitedBy": "convidado por",
  "adminInvite.acceptTitle": "Criar conta de administrador",
  "adminInvite.acceptDesc": "{{by}} convidou-o como administrador da plataforma Surplify.",
  "adminInvite.name": "O seu nome",
  "adminInvite.password": "Palavra-passe",
  "adminInvite.confirm": "Confirmar palavra-passe",
  "adminInvite.create": "Criar conta e entrar",
  "adminInvite.mismatch": "As palavras-passe não coincidem",
  "adminInvite.invalid": "Este convite já não é válido ({{status}}).",
  "adminInvite.deleteAdminHint": "Atenção: está a eliminar uma conta de administrador.",
};

export const navContentRO = {
  "hub.feed.justNow": "chiar acum",
  "hub.feed.title": "Activitate",
  "hub.feed.desc": "Ce s-a întâmplat de la ultima vizită",
  "hub.feed.empty": "Nicio activitate încă.",
  "hub.feed.new": "Nou",
  "hub.feed.newCount": "{{count}} noutăți de la ultima vizită",
  "hub.feed.allCaughtUp": "Nimic nou de la ultima vizită",
  "hub.feed.incoming_request": "<b>{{from}}</b> a solicitat {{qty}} {{uom}} din „{{material}}”",
  "hub.feed.request_status": "Solicitarea dvs. pentru „{{material}}” este acum <b>{{status}}</b>",
  "hub.feed.offer_received": "Ofertă nouă la cererea dvs. „{{wanted}}”: {{qty}} {{unit}} la €{{price}}",
  "hub.feed.offer_status": "Oferta dvs. pentru „{{wanted}}” (€{{price}}/unitate) este acum <b>{{status}}</b>",
  "hub.feed.message": "Mesaj de la <b>{{from}}</b>: {{preview}}",
  "hub.feed.transaction": "Tranzacția {{order}} „{{title}}” ca {{role}} – <b>{{status}}</b>",
  "status.accepted": "Acceptată",
  "status.declined": "Refuzată",
  "status.countered": "Contraofertă",
  "status.withdrawn": "Retrasă",
  "status.awaiting_logistics_confirmation": "În așteptarea confirmării logistice",
  "status.transaction_created": "Tranzacție creată",
  "status.viewed_by_buyer": "Văzută de cumpărător",
  "status.cancelled": "Anulată",
  "status.submitted": "Trimisă",
  "nav.masterData": "Date de bază",
  "nav.hub": "Zona mea",
  "nav.marketplace": "Piață",
  "nav.myListings": "Anunțurile mele",
  "nav.wanted": "Cereri",
  "nav.myOffers": "Ofertele mele",
  "nav.savedSearches": "Căutări salvate",
  "nav.messages": "Mesaje",
  "nav.myReports": "Raportările mele",
  "nav.guide": "Ajutor & FAQ",
  "nav.notificationSettings": "Notificări e-mail",
  "nav.sellerPortal": "Portal vânzător",
  "nav.groupAdminPortal": "Portal admin grup",
  "nav.commission": "Comisioane",
  "nav.subscriptions": "Abonamente",
  "nav.myCompany": "Compania mea",
  "nav.createListing": "Creează anunț",
  "nav.sec.marketplace": "Piață",
  "nav.sec.trade": "Comerț & comunicare",
  "nav.sec.management": "Administrare",
  "nav.sec.portals": "Portaluri",
  "nav.sec.platformAdmin": "Admin platformă",
  "nav.sec.settings": "Setări",
  "nav.quickNav": "Navigare rapidă",
  "nav.groupSwitched": "Grup schimbat: {{name}}",
  "nav.groupSwitchFailed": "Schimbarea grupului a eșuat",
  "cmd.placeholder": "Căutați o pagină sau o acțiune …",
  "cmd.empty": "Niciun rezultat",
  "cmd.pages": "Pagini",
  "cmd.actions": "Acțiuni",
  "cmd.searchFor": "Căutați „{{q}}” în piață",
  "cmd.hint": "Ctrl+K pentru navigare rapidă",
  "breadcrumb.home": "Acasă",
  "breadcrumb.details": "Detalii",
  "breadcrumb.edit": "Editare",
  "breadcrumb.new": "Nou",
  "hub.title": "Zona mea",
  "hub.greeting": "Bine ați revenit, {{name}}",
  "hub.subtitle": "Activitatea, sarcinile deschise și indicatorii dvs. la o privire.",
  "hub.actionsTitle": "Necesită atenție",
  "hub.actionsDesc": "Elemente care așteaptă răspunsul dvs.",
  "hub.noActions": "Totul la zi – nimic în așteptare.",
  "hub.quickActions": "Acțiuni rapide",
  "hub.recentTitle": "Tranzacții recente",
  "hub.recentEmpty": "Nicio tranzacție încă.",
  "hub.viewAll": "Afișați tot",
  "hub.asBuyer": "Cumpărător",
  "hub.asSeller": "Vânzător",
  "hub.tile.my_materials": "Materialele mele",
  "hub.tile.my_listings": "Anunțuri active",
  "hub.tile.watchlist": "Favorite",
  "hub.tile.incoming_requests": "Solicitări primite",
  "hub.tile.outgoing_requests": "Solicitările mele",
  "hub.tile.unread_messages": "Mesaje necitite",
  "hub.tile.offers_received": "Oferte primite",
  "hub.tile.my_offers_active": "Oferte deschise",
  "hub.tile.my_wanted_active": "Cererile mele",
  "hub.tile.wanted_matches": "Cereri potrivite",
  "hub.tile.transactions_active": "Tranzacții în curs",
  "hub.tile.transactions_total": "Total tranzacții",
  "hub.action.incoming_requests": "{{count}} solicitare/ări așteaptă aprobarea dvs.",
  "hub.action.unread_messages": "{{count}} mesaj(e) necitit(e)",
  "hub.action.offers_received": "{{count}} ofertă/e nouă/i la cererile dvs.",
  "hub.action.offers_countered": "{{count}} contraofertă/e necesită răspuns",
  "hub.action.to_ship": "{{count}} comandă/i plătită/e gata de expediere",
  "hub.action.wanted_matches": "{{count}} cerere/i se potrivesc materialelor dvs.",
  "hub.loadError": "Rezumatul nu a putut fi încărcat",
  "adminInvite.button": "Invită admin",
  "adminInvite.title": "Invită administrator platformă",
  "adminInvite.desc": "Persoana primește un link prin e-mail și își creează un cont de administrator.",
  "adminInvite.email": "Adresă e-mail",
  "adminInvite.message": "Mesaj personal (opțional)",
  "adminInvite.send": "Trimite invitația",
  "adminInvite.sent": "Invitație trimisă",
  "adminInvite.sentNoMail": "Invitație creată – e-mailul nu a putut fi trimis. Copiați linkul:",
  "adminInvite.pending": "Invitații admin în așteptare",
  "adminInvite.none": "Nicio invitație în așteptare",
  "adminInvite.revoke": "Revocă",
  "adminInvite.revoked": "Invitație revocată",
  "adminInvite.expires": "valabil până la",
  "adminInvite.invitedBy": "invitat de",
  "adminInvite.acceptTitle": "Creați cont de administrator",
  "adminInvite.acceptDesc": "{{by}} v-a invitat ca administrator al platformei Surplify.",
  "adminInvite.name": "Numele dvs.",
  "adminInvite.password": "Parolă",
  "adminInvite.confirm": "Confirmați parola",
  "adminInvite.create": "Creați contul & autentificare",
  "adminInvite.mismatch": "Parolele nu coincid",
  "adminInvite.invalid": "Această invitație nu mai este valabilă ({{status}}).",
  "adminInvite.deleteAdminHint": "Atenție: ștergeți un cont de administrator.",
};
